import React from 'react';

import PropTypes from 'prop-types';
import { PLACEMENT_BOTTOM, PLACEMENT_MODAL, PLACEMENT_RIGHT } from './constants';

import PlacementDocked from './components/PlacementDocked';
import PlacementModal from './components/PlacementModal';
import Conditions from './components/Conditions';
/* eslint-disable  react/default-props-match-prop-types */
export function PlacementWrapper({ targetPlacement, placement, isShown, setIsShown, onResize, onResizeAA, children }) {
  if (placement !== targetPlacement) {
    return null;
  }

  switch (targetPlacement) {
    case PLACEMENT_BOTTOM:
    case PLACEMENT_RIGHT: {
      return (
        <PlacementDocked isShown={isShown} placement={placement} onResize={onResize} onResizeAA={onResizeAA}>
          {children}
        </PlacementDocked>
      );
    }
    case PLACEMENT_MODAL: {
      return (
        <PlacementModal isShown={isShown} setIsShown={setIsShown} onResize={onResize}>
          {children}
        </PlacementModal>
      );
    }
    default: {
      Logger.warn('RT Conditions - invalid placement: ', placement);
      return null;
    }
  }
}

function ProjectRouteConditions({
  routeType,
  targetPlacement,
  activeStep,
  setActiveStep,
  steps,
  fetchStepData,
  placement,
  setPlacement,
  isShown,
  setIsShown,
  onUnmount,
  resized,
  setResized,
  onActiveStepChange,
  onFullTextLinkClick,
  onIssueCitedCounterClick,
  onExperimentalProcedureOpen,
  onAbstractOpen,
  onAuthorClick,
  saveStepSelectionsHandler,
  onResizeAA,
  loadLastExamples,
}) {
  return (
    <PlacementWrapper
      targetPlacement={targetPlacement}
      placement={placement}
      isShown={isShown}
      setIsShown={setIsShown}
      onResizeAA={onResizeAA}
      onResize={setResized}>
      <Conditions
        routeType={routeType}
        setPlacement={setPlacement}
        setIsShown={setIsShown}
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        steps={steps}
        fetchStepData={fetchStepData}
        onUnmount={onUnmount}
        resized={resized}
        onActiveStepChange={onActiveStepChange}
        onFullTextLinkClick={onFullTextLinkClick}
        onIssueCitedCounterClick={onIssueCitedCounterClick}
        onExperimentalProcedureOpen={onExperimentalProcedureOpen}
        onAbstractOpen={onAbstractOpen}
        onAuthorClick={onAuthorClick}
        saveStepSelectionsHandler={saveStepSelectionsHandler}
        loadLastExamples={loadLastExamples}
      />
    </PlacementWrapper>
  );
}

ProjectRouteConditions.defaultProps = {
  onUnmount: () => null,
  onExperimentalProcedureOpen: () => null,
  onFullTextLinkClick: () => null,
  onIssueCitedCounterClick: () => null,
  onAbstractOpen: () => null,
  onAuthorClick: () => null,
  saveStepSelectionsHandler: () => null,
};
ProjectRouteConditions.propTypes = {
  saveStepSelectionsHandler: PropTypes.func,
  onResizeAA: PropTypes.func,
  loadLastExamples: PropTypes.func,
};
export default ProjectRouteConditions;
